import { FC, useContext } from 'react';

import { useTopicState } from 'src/components/ResumeCard/Actions/Chatik/hooks/useTopicState';
import { ResumeCardActionsContext } from 'src/components/ResumeCard/Actions/Context';
import { useSelector } from 'src/hooks/useSelector';
import { NegotiationTopic } from 'src/models/negotiationTopic.types';
import { LastTopicState } from 'src/models/resumeCard';

import CallButton from 'src/components/ResumeCard/Actions/CallButton';

const getTopicId = (topicState: NegotiationTopic | LastTopicState | null): string | null => {
    if (!topicState) {
        return null;
    }
    if ('topicId' in topicState) {
        return String(topicState.topicId);
    }
    if ('id' in topicState) {
        return String(topicState.id);
    }
    return null;
};

const CallButtonWrapper: FC<{ isMobile?: boolean }> = ({ isMobile }) => {
    const topicState = useTopicState();
    const { resume } = useContext(ResumeCardActionsContext);
    const resumeId = Number(resume._attributes.id);
    const topicId = getTopicId(topicState);

    const isWebcallAvailable = useSelector(({ microFrontends }) =>
        topicId ? Boolean(microFrontends[`webcall-front-${topicId}`]) : false
    );

    if (isWebcallAvailable) {
        return <CallButton isMobile={isMobile} topicId={topicId!} resumeId={resumeId} />;
    }

    return null;
};

export default CallButtonWrapper;
